import { render, staticRenderFns } from "./QRIssueDetail.vue?vue&type=template&id=4cb86118"
import script from "./QRIssueDetail.vue?vue&type=script&lang=js"
export * from "./QRIssueDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports